
import request from '@/utils/request'
// 获取用户试卷信息
export function getPaperOrderList(params) {
    return request({
        url: '/v1/user/getPaperOrderList',
        method: 'get',
        params
    })
}

// 赠送/收到的订单
export function vipSendGoodsList(params) {
    return request({
        url: '/v1/user/vipSendGoodsList',
        method: 'get',
        params,

    })
}
// 获取赠送/领取详情
export function sendInfo(params) {
    return request({
        url: '/v1/goods/sendInfo',
        method: 'get',
        params,
    })
}
// 领取礼物
export function receive(data) {
    return request({
        url: '/v1/goods/receive',
        method: 'post',
        data,
    })
}